import { render } from "./TextMy.vue?vue&type=template&id=27cea23c&scoped=true&ts=true"
import script from "./TextMy.vue?vue&type=script&lang=ts"
export * from "./TextMy.vue?vue&type=script&lang=ts"

import "./TextMy.vue?vue&type=style&index=0&id=27cea23c&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cea23c"]])

export default __exports__